// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/GestaoClientes_CarregaClientesAtivosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for /gestao_clientes/carrega_clientes_ativos
 *
 * Returns array of active cliente records with compromissos.
 */
import type { GestaoClientes_CarregaClientesAtivosRow } from './GestaoClientes_CarregaClientesAtivosRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type GestaoClientes_CarregaClientesAtivosResponseDados = GestaoClientes_CarregaClientesAtivosRow[];

export type GestaoClientes_CarregaClientesAtivosResponse = ApiResponse<GestaoClientes_CarregaClientesAtivosResponseDados>;

registerResponseContract('GestaoClientes_CarregaClientesAtivosResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      cliente_id:            { type: 'string',  required: true },
      acoes:                 { type: 'string',  required: true },
      franquia_id:           { type: 'string',  required: true },
      nome:                  { type: 'string',  required: true },
      documento:             { type: 'string',  required: false },
      ddi:                   { type: 'string',  required: false },
      ddd:                   { type: 'string',  required: false },
      telefone:              { type: 'string',  required: false },
      rua:                   { type: 'string',  required: false },
      cep:                   { type: 'string',  required: false },
      numero:                { type: 'string',  required: false },
      complemento:           { type: 'string',  required: false },
      bairro:                { type: 'string',  required: false },
      cliente_location_id:   { type: 'string',  required: false },
      cliente_location_type: { type: 'string',  required: false },
      data_cadastro:         { type: 'string',  required: false },
      status:                { type: 'string',  required: false },
      franquia:              { type: 'string',  required: false },
      localidade:            { type: 'string',  required: false },
      qtdOrcamentos:         { type: 'string',  required: false },
      compromissos: {
        type: 'array',
        required: false,
        items: {
          compromisso_id:                   { type: 'string',  required: true },
          compromisso_operador_user_id:     { type: 'string',  required: true },
          compromisso_orcamento_id:         { type: 'string',  required: true },
          compromisso_franquia_id:          { type: 'string',  required: true },
          compromisso_titulo:               { type: 'string',  required: false },
          compromisso_total:                { type: 'string',  required: false },
          compromisso_cor_fundo:            { type: 'string',  required: false },
          compromisso_data_hora_inicio:     { type: 'string',  required: false },
          compromisso_data_hora_fim:        { type: 'string',  required: false },
          compromisso_nome_cliente:         { type: 'string',  required: true },
          compromisso_origem:               { type: 'string',  required: false },
          compromisso_status:               { type: 'string',  required: true },
          compromisso_observacao:           { type: 'string',  required: false },
          compromisso_forma_pagamento:      { type: 'string',  required: true },
          compromisso_numero_parcelas:      { type: 'string',  required: true },
          compromisso_tipo:                 { type: 'string',  required: true },
          compromisso_checkin:              { type: 'string',  required: false },
          compromisso_checkout:             { type: 'string',  required: false },
          compromisso_entrou_sem_problemas: { type: 'string',  required: false },
          compromisso_data_cadastro:        { type: 'string',  required: false },
          compromisso_status_financeiro:    { type: 'string',  required: false },
          compromisso_foi_reagendado:       { type: 'string',  required: false },
          compromisso_valor_recebido:       { type: 'string',  required: true },
          orcamento_id:                     { type: 'string',  required: true },
          orcamento_franquia_id:            { type: 'string',  required: true },
          orcamento_user_id:                { type: 'string',  required: true },
          orcamento_cidade_id:              { type: 'string',  required: false },
          orcamento_valor:                  { type: 'string',  required: true },
          orcamento_origem:                 { type: 'string',  required: false },
          orcamento_data:                   { type: 'string',  required: false },
          orcamento_status:                 { type: 'string',  required: true },
          orcamento_observacao:             { type: 'string',  required: false },
          orcamento_cliente_id:             { type: 'string',  required: false },
          orcamento_location_id:            { type: 'string',  required: false },
          orcamento_location_type:          { type: 'string',  required: false },
          orcamento_data_cadastro:          { type: 'string',  required: false },
        },
      },
      qtdCompromissos:       { type: 'string',  required: false },
      dataUltimoCompromisso: { type: 'string',  required: false },
      totalFaturadoCliente:  { type: 'number',  required: false },
    },
  },
})
